<template>
  <div class="PageCourseVideo">
    <app-PageCourseVideo></app-PageCourseVideo>
  </div>
</template>

<script>
// @ is an alias to /src
import pageCourseVideo from "../components/pageCourseVideo/Premium";
export default {
  name: "about",
  components: {
    appPageCourseVideo: pageCourseVideo
  }
};
</script>
